import '../../pages/Login/Login.css';
import './Pop.css';
import '../../pages/Register/Register.css';
import '../../component/layouts/Style.css';

import React, { useContext, useState } from 'react';
import { Link  } from 'react-router-dom';
import LoginPop from "./LoginPop";
import PortalWrapper from "./PortalWrapper"; 


import { Container, Row, Col } from 'reactstrap';

import { AppContext } from '../../context/AppContext';

const RegisterPop = ({ onClose, onSwitchToLogin }) => {

 const {token, setToken, setShowForget} = useContext(AppContext);

    const [preview, setPreview] = useState(null);

    const [showLogin, setShowLogin] = useState(false);
    
    const [showRegister, setShowRegister] = useState(true);
    

    const [formData, setFormData] = useState({
            name: '',
            email:'',
            password:'',
            phone:'',
            bio:'',
            username:'',
            foot: '',
            fav_number: '',
            position: '',
            file: ''
    })

    const [errors, setErrors] = useState({}); 


const handleChanges = (e) => {
  const { name, value, files } = e.target;

  if (name === "file") {
    const file = files[0];
    setFormData({ ...formData, file });

    if (file) {
      setPreview(URL.createObjectURL(file));
    } else {
      setPreview(null);
    }
  } else {
    setFormData({ ...formData, [name]: value });
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); 

    console.log(111);
    

    console.log('====================================');
    console.log(formData);
    console.log('====================================');

    console.log(1);
    
const formToApi = new FormData();
      formToApi.append("name", formData.name);
      formToApi.append("username", formData.username);
      formToApi.append("phone", formData.phone);
      formToApi.append("email", formData.email);
      formToApi.append("password", formData.password);
      formToApi.append("bio", formData.bio);
      formToApi.append("fav_number", formData.fav_number);
      formToApi.append("foot", formData.foot);
      formToApi.append("position", formData.position);
      formToApi.append("file", formData.file);




    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/register', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: formToApi
      });


      const data = await response.json();

      console.log(data);
      

      if (response.ok) {
            alert("✅ تم التسجيل بنجاح!");
            console.log(data);

            localStorage.setItem('token', data.token); 
            localStorage.setItem('name', formData.name); 

            setToken(data.token);
              onClose();

            // navigate('/home'); // حول المستخدم على الصفحة الرئيسية


        } else if (response.status === 422) {
            setErrors(data.errors);
        } else {
            console.log(data.message);
            
            // alert("❌ فيه مشكلة: " + (data.message || "حاول تاني"));
        }

    } catch (error) {
      console.error(error);
      alert('⚠ حصل خطأ في الاتصال بالسيرفر');
      alert(error);
    }
  };

  if (showLogin) {
  return <LoginPop onClose={() => {setShowLogin(false); setShowRegister(false);}} />;
}

  return (

    <PortalWrapper>
    <div className="popup-overlay">
      <div className="popup-panel">
        <div className="panel-header">
          <button onClick={onClose}>✖</button>
        </div>
        <div className="panel-body">
            <Container>
                <Row>
                    <Col lg='6' md='6' sm='12' className='loginBox'>
                    <form onSubmit={handleSubmit} className='material-form'>
                    <h1>Register</h1>

                    <div className='input-field'>
                        <input type='text' placeholder='name' name='name'  value={formData.name}
                                onChange={handleChanges} ></input>
                        <label>Name</label>
                        <span className="bar"></span>
                        {errors.name && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.name[0]}
                                </div>
                        )}
                    </div>
                    <div className='input-field'>
                        <input type='text'
                                placeholder='enter your username'
                                name='username' 
                                value={formData.username}
                                onChange={(e) => handleChanges(e)} 
                        >                                   
                        </input>
                        <label>UserName</label>
                        <span className="bar"></span>
                        {errors.username && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.username[0]}
                                </div>
                        )}
                    </div>

                    <div className='input-field'>
                        <input type='text' placeholder='email' name='email'  value={formData.email}
                                onChange={handleChanges} ></input>
                        <label>Email</label>
                        <span className="bar"></span>
                        {errors.email && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.email[0]}
                                </div>
                        )}
                    </div>

                    <div className='input-field'>
                        <input type='number' placeholder='phone' name='phone'  value={formData.phone}
                                onChange={handleChanges} ></input>
                        <label>Phone</label>
                        <span className="bar"></span>
                        {errors.phone && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.phone[0]}
                                </div>
                        )}
                    </div>


                    
                <div className="input-field">

                  <input type="radio" name='foot' className='inputradio' id='rightFoot' style={{ display:'inline', width:'auto', height:'auto', marginLeft:'20px'}} checked={formData.foot === 'left'}  value="left" onChange={handleChanges} />
                  <span style={{ marginRight:'20px' }}> L-Foot</span>
                  <input type="radio" name='foot' className='inputradio' id='leftFoot' style={{ display:'inline-block', width:'auto', height:'auto' }} checked={formData.foot === 'right'}  value="right" onChange={handleChanges}  />
                  <span style={{ marginRight:'20px' }}> R-Foot</span>


                  <label>Foot*</label>
                  <span className="bar"></span>
                  {errors.foot && <div className="errorMessage">{errors.foot[0]}</div>}
                </div>



            <div className="input-field">
                  <select name="position" className='inputField' value={formData.position} onChange={handleChanges} >
                    <option value="" disabled >Select Your Position</option>
                    <option value="GK" >GK</option>
                    <option value="CB">CB</option>
                    <option value="RB">RB</option>
                    <option value="LB">LB</option>
                    <option value="CDM">CDM</option>
                    <option value="CM">CM</option>
                    <option value="CAM">CAM</option>
                    <option value="LW">LW</option>
                    <option value="RW">RW</option>
                    <option value="SS">SS</option>
                    <option value="CF">CF</option>
                    <option value="ST">ST</option>
                  </select>
                  <label>Position</label>
                  <span className="bar"></span>
                  {errors.position && <div className="errorMessage">{errors.position[0]}</div>}
            </div>
        

                <div className='input-field'>
                        <input type='number' placeholder='Favourite Number' name='fav_number'  value={formData.fav_number}
                                onChange={handleChanges} ></input>
                        <label>favourite Number</label>
                        <span className="bar"></span>
                        {errors.fav_number && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.fav_number[0]}
                                </div>
                        )}
                </div>



                    <div className='input-field'>

                        <textarea name="bio" id="bio" cols="30" rows="10"  placeholder='enter your bio' value={formData.bio} onChange={(e) => handleChanges(e)}>

                        </textarea>


                        <label>Bio</label>
                        <span className="bar"></span>
                    {errors.bio && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                            {errors.bio[0]}
                            </div>
                        )}

                    </div>

                    <div className='input-field'>
                        <input type='file' placeholder='select your photo' name='file' onChange={(e) => handleChanges(e)}  >
                        </input>
                        <label>Photo</label>
                        <span className="bar"></span>   
                        
                    </div>

                    {preview && (
                        <div style={{ marginTop: "10px" }}>
                            <img
                            src={preview}
                            alt="Preview"
                            style={{ maxWidth: "200px", borderRadius: "10px" }}
                            />
                        </div>
                        )}

                    <div className='input-field'>
                        <input type='password' placeholder='password' name='password'  value={formData.password}
                                onChange={handleChanges} ></input>
                        <label>Password</label>
                        <span className="bar"></span>
                        {errors.password && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.password[0]}
                                </div>
                        )}
                    </div>


                    <button type='submit'>Submit</button>
                    <div className='rememberForget'>
                    <Link to="#" onClick={(e) => { e.preventDefault(); onSwitchToLogin(); }}>already have an account</Link>

                         / 
                       <Link to="#" onClick={(e) => { 
                        e.preventDefault(); 
                        onClose(); 
                        setShowForget(true); 
                      }}>Forget Password</Link>
                      
                      </div>
                    </form>
                    </Col>
                </Row>
            </Container>
        </div>
      </div>
    </div>

  </PortalWrapper>

  );


};


export default RegisterPop;
